module.exports = __webpack_public_path__ + "pigmentace_4_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/dermatologie/pigmentace_4_before.jpg
// module id = 976
// module chunks = 0